import React, {Component} from 'react';
import {
    Popup,
    Button,
    Header,
    Icon,
    Loader,
    Menu,
    Message,
    Dropdown,
    Input,
    Pagination,
    Table,
} from 'semantic-ui-react';
import moment from "moment";
import connect from "react-redux/es/connect/connect";
import {FormattedNumber} from "react-intl";
import {dynamicTableList} from "../../actions/DynamicTableDataAction";
import DynamicTableData from "../../data/DynamicTableData";
import BranchOfficeData from "../../data/BranchOfficeData";
import DayPickerInput from "react-day-picker/DayPickerInput";
import helpers from "../../functions/helpers";

let GLOBAL = require('../../data/globals');

class DynamicTable extends Component {
    constructor(props){
        super(props);
        this.state = {
            table: props,
            loading: true,
            search: props.search ? props.search:'',
            date_filter: null,
            branch_offices: [],
            id: props.id,
            search_fields: this.props.search_fields,
            other_actions_components: props.other_actions_components ? props.other_actions_components:[],
            search_fields_values: {},
            data: {},
            is_open: false
        };
        this.loadData = this.loadData.bind(this)
    }

    componentWillMount(){
        this.loadData(this.state.search, 1);
        if(this.state.search_fields){
            let has_branch_office = this.state.search_fields.find(search_field => search_field.type === 'branch_office')
            if(has_branch_office){
                this.getBranchOffices()
            }
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.data.id === this.state.id){
            this.setState({data:nextProps.data.data})
        }
        if(nextProps.data.refresh){
            this.setState({is_open: false})
            this.loadData('', 1)
        }
    }

    async getBranchOffices() {
        let branch_offices = await BranchOfficeData.listAll();
        branch_offices.push({key: "", value: "", text: "Todas las sucursales"})
        this.setState({branch_offices});
    }

    loadData = (search, page) => {
        this.setState({loading: true});
        DynamicTableData.list(this.props.url, search, page).then(data=>{
            if(!data.hasOwnProperty('detail')){
                this.props.dynamicTableList({data, id:this.props.id});
            }else{
                this.props.dynamicTableList(GLOBAL.TABLE_NO_DATA);
            }
        }).catch(()=>{
            this.props.dynamicTableList(GLOBAL.TABLE_NO_DATA)
        }).finally(()=>{
            this.setState({loading:false});
        });
    };

    handleSearchChange = (event) => {
        this.setState({search: event.target.value});
    };

    handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.handleSearch();
        }
    };

    handleSearchFieldsChange = (e, { name, value, type }) => {
        let search_fields_values = this.state.search_fields_values
        search_fields_values[name] = value
        this.setState({search_fields_values})
        if(type !== 'text'){
            this.handleSearch()
        }
    }
    handleSearchFieldsDateClick = (selectedDay, modifiers, input) => {
        let date = moment(selectedDay).format("MM/DD/YYYY");
        this.handleSearchFieldsChange(null, {name: input.props.name, value: date, type:input.props.type})
    };

    handleSearch = (page) => {
        this.loadData(this.state.search_fields ? this.state.search_fields_values:this.state.search, page||1);
        this.setState({ is_open: false });
    };

    handlePaginationChange = (e, { activePage }) => {this.handleSearch(activePage);};

    toggleOpen = () => this.setState({ is_open: !this.state.is_open });

    preventClosing = e => e.stopPropagation();

    cellType = (value, key, data) => {
        if(this.state.table.money_fields && this.state.table.money_fields.includes(key)){
            // eslint-disable-next-line
            return <FormattedNumber value={value} currency="USD" style="currency" maximumFractionDigits={0} minimumFractionDigits={0}/>;
        }else if(this.state.table.datetime_fields && this.state.table.datetime_fields.includes(key)){
            return moment(value).format('M/DD/YYYY - h:mm A');
        }else if(this.state.table.date_fields && this.state.table.date_fields.includes(key)){
            return moment(value).format('M/DD/YYYY');
        }else if(this.state.table.boolean_fields && this.state.table.boolean_fields.includes(key)){
            return value ? 'Si':'No';
        }else if(this.state.table.child_fields && this.state.table.child_fields[0].hasOwnProperty(key) && value){
            return value[this.state.table.child_fields[0][key]];
        }else if(this.state.table.component_fields && this.state.table.component_fields[0].hasOwnProperty(key)){
            const ComponentField = this.state.table.component_fields[0][key];
            return <ComponentField {...data}/>;
        }else if(this.state.table.percentage_fields && this.state.table.percentage_fields.includes(key)){
            return `${value}%`;
        }else{
            return !!value ? value:'_';
        }
    };

    render() {
        return (
            <div>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell width={4}>
                                <Menu secondary>
                                    <Menu.Item>
                                        <Header as='h2'>
                                            <Header.Content>
                                                {this.state.table.title}
                                            </Header.Content>
                                        </Header>
                                    </Menu.Item>
                                </Menu>
                            </Table.HeaderCell>
                            <Table.HeaderCell width={3} textAlign='right'>
                                <Input
                                    fluid
                                    icon={<Icon name='search' circular link onClick={() => this.handleSearch(1)}/>}
                                    placeholder={`Buscar ${this.state.search_fields ? 'por ' + this.state.search_fields.find(search_field => search_field.is_main).name:this.state.table.name}`}
                                    value={this.state.search_fields ? this.state.search_fields_values[this.state.search_fields.find(search_field => search_field.is_main).id]:this.state.search}
                                    onChange={this.state.search_fields ? this.handleSearchFieldsChange:this.handleSearchChange}
                                    onKeyPress={this.handleSearchKeyPress}
                                    name={this.state.search_fields ? this.state.search_fields.find(search_field => search_field.is_main).id:'search'}
                                />
                            </Table.HeaderCell>
                            {this.state.table.other_actions === undefined || this.state.table.other_actions === true ? <Table.HeaderCell width={2} textAlign='right'>
                                    <Dropdown
                                        text='Otras Acciones'
                                        icon='ellipsis vertical'
                                        fluid
                                        labeled
                                        button
                                        closeOnEscape
                                        onClick={this.toggleOpen}
                                        open={this.state.is_open}
                                        className='icon'
                                    >
                                        <Dropdown.Menu onClick={e => e.stopPropagation()}>
                                            {this.state.table.can_add ?
                                                <React.Fragment>
                                                    <div style={{margin:6}}>
                                                        <Button
                                                            primary
                                                            icon='add'
                                                            content={`Agregar ${this.state.table.name}`}
                                                            fluid
                                                            onClick={()=>{
                                                                this.setState({is_open: false})
                                                                this.props.callbackDynamicTable({event:'add'})
                                                            }}
                                                        />
                                                    </div>
                                                </React.Fragment> :null
                                            }

                                            {this.state.search_fields ? this.state.search_fields.filter(search_field => search_field.is_main ===false).map(search_field => {
                                                if (search_field['type'] === 'branch_office') {
                                                    return <React.Fragment>
                                                        <Dropdown.Header content='Filtrar por sucursal:'/>
                                                        {this.state.branch_offices.map(branch_office => {
                                                            return <Dropdown.Item
                                                                key={branch_office.key}
                                                                text={branch_office.text}
                                                                onClick={() => this.handleSearchFieldsChange(null, {
                                                                    name: search_field.id,
                                                                    value: branch_office.value,
                                                                    type: search_field.type
                                                                })}
                                                            />
                                                        })}
                                                        <Dropdown.Divider/>
                                                    </React.Fragment>
                                                } else if (search_field['type'] === 'date') {
                                                    return <React.Fragment>
                                                        <Dropdown.Header content={`Filtrar por ${search_field.name}`}/>
                                                        <Input fluid key={search_field.id}>
                                                             <DayPickerInput
                                                                 readOnly
                                                                 placeholder="MM/DD/YYYY"
                                                                 format="MM/DD/YYYY"
                                                                 name={search_field.id}
                                                                 type={search_field.type}
                                                                 value={this.state.search_fields_values[search_field.id]}
                                                                 onDayChange={this.handleSearchFieldsDateClick}
                                                             />
                                                        </Input>
                                                    </React.Fragment>
                                                }else if (search_field['type'] === 'list') {
                                                    return <React.Fragment key={helpers.generate_token()}>
                                                        <Dropdown.Header content={`Filtrar por ${search_field.name}`}/>
                                                        {search_field.values.map(value =>{
                                                            return <Dropdown.Item
                                                                key={value.text}
                                                                text={value.text}
                                                                onClick={() => this.handleSearchFieldsChange(null, {
                                                                    name: search_field.id,
                                                                    value: value.value,
                                                                    type: search_field.type
                                                                })}
                                                            />
                                                        })}
                                                    </React.Fragment>
                                                }else if (search_field['type'] === 'text') {
                                                    return <React.Fragment key={helpers.generate_token()}>
                                                        <Dropdown.Header content={`Filtrar por ${search_field.name}`}/>
                                                        <Input
                                                            onClick={this.preventClosing}
                                                            fluid
                                                            width={4}
                                                            placeholder={`Buscar por ${search_field.name}`}
                                                            name={search_field.id}
                                                            onChange={this.handleSearchFieldsChange}
                                                            onKeyPress={this.handleSearchKeyPress}
                                                            action={<Button onClick={() => this.handleSearch()} content={"Buscar"} />}
                                                        />
                                                    </React.Fragment>
                                                }
                                            }):null}
                                            {this.state.other_actions_components.map(other_action => other_action())}

                                        </Dropdown.Menu>
                                    </Dropdown>
                            </Table.HeaderCell>:null}
                        </Table.Row>
                    </Table.Header>
                </Table>
                <Table selectable striped>
                    <Table.Header>
                        <Table.Row>
                            {
                                this.state.table.headers.map((header, index) => {
                                    return <Table.HeaderCell key={index}>{header}</Table.HeaderCell>
                                })
                            }
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {this.state.loading ?<Table.Row>
                                <Table.Cell colSpan={this.state.table.headers.length}>
                                    <Loader active inline='centered'>Cargando</Loader>
                                </Table.Cell>
                            </Table.Row>:
                            this.state.data.results.map(data =>{
                                let keys = Object.keys(data);
                                let rows = keys.map((key, index) =>{
                                    if(this.state.table.values.includes(key) && key!=='id'){
                                        return <Table.Cell key={index}>
                                            {this.cellType(data[key], key, data)}
                                        </Table.Cell>
                                    }else{
                                        return null;
                                    }
                                });
                                if(this.state.table.has_actions){
                                    rows.push(
                                        <Table.Cell key={helpers.generate_token()}>
                                            <Button.Group basic size='small'>
                                                {this.state.table.more_actions ? this.state.table.more_actions.map(action => action(data)):null}
                                                {this.state.table.history ? <Popup
                                                    trigger={<Button icon='history' onClick={()=>this.props.callbackDynamicTable({event:'history', data})}/>}
                                                    content='Historial'
                                                    position='top left'
                                                />:null}
                                                {this.state.table.navigate ? <Popup
                                                    trigger={<Button icon='chevron circle right' onClick={()=>this.props.callbackDynamicTable({event:'navigate', data})}/>}
                                                    content='Ir'
                                                    position='top left'
                                                />:null}
                                                {this.state.table.user ?  <Popup
                                                    trigger={<Button icon='user'/>}
                                                    content='Usuarios'
                                                    position='top left'
                                                />:null}
                                                {this.state.table.images ? <Popup
                                                    trigger={<Button icon='image' onClick={()=>this.props.callbackDynamicTable({event:'images', data})}/>}
                                                    content='Fotos'
                                                    position='top left'
                                                />:null}
                                                {this.state.table.edit ?
                                                    <Popup
                                                        trigger={<Button icon='pencil' onClick={()=>this.props.callbackDynamicTable({event:'edit', data})}/>}
                                                        content='Editar'
                                                        position='top left'
                                                    />: null}
                                                {this.state.table.delete ? <Popup
                                                    trigger={<Button icon='trash' onClick={()=>this.props.callbackDynamicTable({event:'delete', data})}/>}
                                                    content='Borrar'
                                                    position='top left'
                                                />:null}
                                            </Button.Group>
                                        </Table.Cell>
                                    );
                                }
                                if(this.state.table.actions){
                                    const ComponentField = this.state.table.actions;
                                    rows.push(<ComponentField key={helpers.generate_token()} />);
                                }
                                return <Table.Row key={helpers.generate_token()}>
                                    {rows}
                                </Table.Row>
                            })}
                        {
                            this.state.data.results <= 0 && !this.state.loading ? <Table.Row>
                                <Table.Cell
                                    colSpan={this.state.table.headers.length}>
                                    <Message
                                        icon='frown outline'
                                        header='No hay resultados'
                                    />
                                </Table.Cell>
                            </Table.Row>:null
                        }
                    </Table.Body>

                    {this.state.table.can_add || this.state.table.pagination ? <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan={this.state.table.headers.length} textAlign='right'>
                                {this.state.table.pagination ? <Pagination
                                    activePage={this.state.data.number ? this.state.data.number:1}
                                    boundaryRange={3}
                                    onPageChange={this.handlePaginationChange}
                                    size='mini'
                                    siblingRange={1}
                                    totalPages={this.state.data.total_pages ? this.state.data.total_pages:1}
                                    ellipsisItem={undefined}
                                    prevItem={undefined}
                                    nextItem={undefined}
                                />:null}
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>:null}
                </Table>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        data: state.get('dynamic_table_data'),
    };
};

function mapDispatchToProps(dispatch){
    return {
        dynamicTableList(data){
            dispatch(dynamicTableList(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DynamicTable)



// WEBPACK FOOTER //
// ./src/components/extras/DynamicTable.js